import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {maybeAppendInactive} from '@/utilities/utils'

const state = {
  cities: [],
  subdivisions: [],
  counties: [],
  streets: []
}

const getters = make.getters(state)
const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async cityStartsWith({ state }, cityName) {
      const url = `cities/search/findByNameStartsWithIgnoreCaseAndActiveOrderByNameAsc?name=${cityName}&active=true`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.cities = response.data
      }

      return response
    },
    async streetStartsWith({ state }, streetName) {
      const url = `streets/search/findByNameStartsWithIgnoreCaseOrderByNameAsc?name=${encodeURIComponent(streetName)}`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.streets = maybeAppendInactive(response.data)
      }

      return response
    },
    async streetStartsWithAndCityEquals({ state }, payload) {
      const url = `streets/search/findByNameStartsWithIgnoreCaseAndCity?name=${encodeURIComponent(payload.streetName)}&city=${encodeURIComponent(payload.city)}`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.streets = maybeAppendInactive(response.data)
      }

      return response
    },
    async streetEqualsAndCityEquals({ state }, payload) {
      const url = `streets/search/findByNameAndCityAndActive?name=${encodeURIComponent(payload.streetName)}&city=${encodeURIComponent(payload.city)}&active=true`
      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        state.streets = response.data
      }

      return response
    }
  }
}
